/// <reference path="../definitions/jquery/index.d.ts" />
/// <reference path="../definitions/moment/moment.d.ts" />
/// <reference path="../../../../node_modules/foundation-sites/dist/js/foundation.d.ts" />

namespace IREP {
    'use strict';

    export interface IREPOptions {
        appUrl: string;
        appUrlSecure: string;
        apiUrl: string;
        apiUrlSecure: string;
        user: any;
        pJaxTimeout: number;
        isRTL: boolean;
        isMotech: boolean;
        fileName: string;
        isMobileApp: boolean;
    }

    export interface ICallApiOptions {
        url: string;
        type: string;
        anonymous?: boolean;
        secure?: boolean;
        data: any;
        headers?: any;
        traditional?: boolean;
    }

    export interface IGetHtmlOptions {
        url: string;
        type: string;
        anonymous?: boolean;
        secure?: boolean;
        data: any;
        headers?: any;
        traditional?: boolean;
        dataType?: string;
    }

    interface IInitializer {
        hasLoaded: boolean;
        isLoading: boolean;
        queue: Array<() => void>;

        add: ((callback: any) => any);

        insertAtBeginning: ((callback: any) => any);

        ready: (() => any);

        readyFirst: (() => any);

        execute: (() => void);
    }

    export class IREP {
        public options: IREPOptions;
        private initializer: IInitializer;

        constructor(options: IREPOptions, initializer: IInitializer) {
            this.options = options;
            this.initializer = initializer;
        }

        private configureMoment() {
            var cultureCode = this.options.user.cultureCode;

            // culture code overrides to map irep culture code to moment locale
            switch (cultureCode) {
                case "zh-CHS":
                    cultureCode = "zh-cn";
                    break;

            }

            if (this.options.isMotech) {
                moment.locale(cultureCode);
            }
            this.showRelativeDates();
        }

        ready(callback: () => any) {
            this.initializer.add(callback);
        }

        readyFirst(callback: () => any) {
            this.initializer.insertAtBeginning(callback);
        }

        execute() {
            this.setupJqueryOptions();
            this.configureMoment();
            this.initializeFoundation();
            this.initializer.execute();

            // todo: extract into method
            // deal with navigation button presses
            $(window).on('popstate', (e) => {
                const code = localStorage.getItem("code") as string;
                if (localStorage.getItem("closed") === "false" && code !== "") {
                    this.closeFullPageQuiz("partial", code);
                }
                else if (history.state && history.state.start) {
                    history.replaceState(null, "");
                    history.back();
                }
            });
        }

        private setupJqueryOptions() {
            $.ajaxSetup({
                cache: false
            });
        }

        private initializeFoundation() {
            (<any>$(document)).foundation(); // cast to any to get it to stop complaining
        }

        private newSchoolcallApi(options: ICallApiOptions): JQueryXHR {
            options = $.extend({}, { type: 'GET', secure: false, anonymous: false, data: {}, headers: {} }, options);
            var headers = $.extend({}, { "PaxUID": options.anonymous ? '' : this.options.user.currentUID }, options.headers);

            var xhr = $.ajax({
                dataType: "json",
                url: this.options.apiUrlSecure + options.url,
                contentType: 'application/json',
                type: options.type,
                headers: headers,
                traditional: options.traditional,
                data: options.type === "POST" ? JSON.stringify(options.data) : options.data
            });

            return xhr;
        }

        callApi(options: ICallApiOptions | string, type?: string, data?: any, doneCallback?: () => any, failCallback?: () => any): JQueryXHR {
            return this.newSchoolcallApi(<ICallApiOptions>options);
        }

        getHtml(options: IGetHtmlOptions): JQueryXHR {
            options = $.extend({}, { traditional: false, type: 'GET', secure: false, anonymous: false, data: {}, headers: {}, dataType: "html" }, options);
            var headers = $.extend({}, options.headers);

            var xhr = $.ajax({
                dataType: options.dataType,
                url: (options.secure === true ? this.options.appUrlSecure : this.options.appUrl) + this.options.user.site + '/' + options.url,
                contentType: 'application/json',
                type: options.type,
                headers: headers,
                traditional: options.traditional,
                data: options.type === "POST" ? JSON.stringify(options.data) : options.data
            });

            return xhr;
        }

        postFile(options: any): JQueryXHR {
            options = $.extend({}, { secure: false, anonymous: false, data: {}, headers: {} }, options);
            var headers = $.extend({}, options.headers);

            var xhr = $.ajax({
                type: 'post',
                url: this.options.appUrl + this.options.user.site + '/' + options.url,
                contentType: false,
                headers: headers,
                processData: false,
                data: options.data
            });

            return xhr;
        }

        track(code: string, type: string, label: string, value: string, data: string): JQueryXHR {
            return this.getHtml({ type: "POST", url: 'api/tracker', data: { code: code, type: type, label: label, value: value, data: data } });
        }

        trackPage(type: string, label: string, value: string, data: string): JQueryXHR {
            return this.track('IREP6-' + this.options.user.site + '-Page-' + this.options.fileName, type, label, value, data);
        }

        logTimings(): void {
            try {
                if (!(window.performance && window.performance.timing)) {
                    return;
                }

                const timings = {
                    url: window.location.pathname,
                    querystring: window.location.search,
                    hash: window.location.hash,
                    latency: window.performance.timing.responseStart - window.performance.timing.fetchStart,
                    transfer: window.performance.timing.responseEnd - window.performance.timing.responseStart,
                    domInteractive: window.performance.timing.domInteractive - window.performance.timing.domLoading,
                    domComplete: window.performance.timing.domComplete - window.performance.timing.domInteractive,
                    onLoad: window.performance.timing.loadEventEnd - window.performance.timing.loadEventStart,
                    browserHeight: window.innerHeight,
                    browserWidth: window.innerWidth,
                    devicePixelRatio: window.devicePixelRatio
                }
                this.getHtml({ type: 'POST', url: 'api/cerebro/ct', data: timings });
            } catch (e) { }
        }

        redirect(url: string) {
            window.location.href = url;
        }

        showRelativeDates() {
            $.each($(".moment"), function (index, item) {
                var that = $(item);
                var momentDate = moment(that.data("date"));
                var relativeDate = momentDate.fromNow();
                if (that.data("showActualDate")) {
                    that.text(that.attr("title"));
                    that.attr("title", relativeDate);
                } else {
                    that.text(relativeDate);
                }

            });
        };

        generateSiteLink(url: string): string {
            return this.options.appUrl + this.options.user.site.toLowerCase() + url;
        }

        getBrowser() {
            var ua = navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
            if (/trident/i.test(M[1])) {
                tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
                return { name: 'IE', version: (tem[1] || '') };
            }
            if (M[1] === 'Chrome') {
                tem = ua.match(/\bOPR|Edge\/(\d+)/)
                if (tem != null) { return { name: 'Opera', version: tem[1] }; }
            }
            M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
            if ((tem = ua.match(/version\/(\d+)/i)) != null) { M.splice(1, 1, tem[1]); }
            return {
                name: M[0],
                version: M[1]
            };
        }

        launchFullPageQuiz(code: string, type: string, cultureCode: string = "", countryCode: string = "") {

            if (type.toLowerCase() === "pdtraining" || (type.toLowerCase() === "partner" && !this.options.isMobileApp)) {
                window.open(this.generateSiteLink("/FullPageQuiz?code=" + code), '_newtab');

                // call the close with the type external so it doesn't mess with the history logic
                this.closeFullPageQuiz("external", code);
            }
            else if (type.toLowerCase() === "partner" && this.options.isMobileApp)
            {
                //can't do partner showcase trainings on mobile in a new tab
                window.location.href = this.generateSiteLink("/FullPageQuiz?code=" + code);
                // call the close with a type that doesn't exist so that it doesn't do any history modification and only closes the loader and what not
                this.closeFullPageQuiz("none", code);
            }
            else if ($('#FullPageQuiz').length === 0) {
                // modify the history using the api and local storage variables
                // if we've already pushed then replace, otherwise push
                localStorage.setItem("closed", "false");
                localStorage.setItem("code", code);
                if (history.state && history.state.fullpagequiz) {
                    history.replaceState({ "fullpagequiz": true, "prevurl": window.location.href }, "", this.generateSiteLink("/learning/details?code=" + code));
                } else {
                    // replace the current state metadata so that we know this was clicked so we can go back appropriately when needed, then push a new state
                    history.replaceState({ "start": true }, "");
                    history.pushState({ "fullpagequiz": true, "prevurl": window.location.href }, "", this.generateSiteLink("/learning/details?code=" + code));
                }

                //Have to hide the modal first to prevent the double scroll bar
                let $modal = $('.education35-modal[data-activitycode="' + code + '"]');
                if ($modal.length > 0) {
                    $modal.each((i, e) => {
                        try {
                            $(e).foundation('close');
                        } catch (ex) {}
                    });
                }

                //Let's make this work for spanish and french
                let url = this.generateSiteLink("/FullPageQuiz?code=" + code + "&inframe=true");
                if (cultureCode !== "") {
                    url += ("&cultureCode=" + cultureCode);
                }

                if (countryCode !== "") {
                    url += ("&countryCode=" + countryCode);
                }

                let iframe = $('<iframe id="FullPageQuiz">');
                iframe.attr('src', url);

                //Build loader on the fly
                let loaderWrapper = $('<div id="FPQuizLoader" class="cell small-12 grid-x align-middle">');
                let loaderContainer = $('<div class="cell small-12 text-center">');
                let loader = $('<div class="loader35"><div></div><div></div><div></div><div></div></div>');
                loaderContainer.append(loader);
                loaderWrapper.append(loaderContainer);
                $('body').prepend(loaderWrapper);

                iframe.css('opacity', '0');

                //If desktop append it to the body if not then append it to the mobile app container
                if (this.options.isMobileApp) {
                    $("#mobileAppContainer").append(iframe);
                }
                else {
                    $('body').append(iframe);
                }

                iframe.on("load", function () {
                    iframe.css('opacity', '1');
                    loaderWrapper.remove();
                    $('body').css('overflow', 'hidden');
                });
            }
        };

        closeFullPageQuiz(refreshType: string, code: string) {
            var self = this;
            var refreshTimeout = 400;

            $('body').css('overflow', 'initial');
            $('#FPQuizLoader').remove();
            $('#FullPageQuiz').remove();

            //May eventually want to fully reset the userdata object
            if (refreshType.toLowerCase() === "partial" || refreshType.toLowerCase() === "external") {

                var toolVideo = $(`.education35-modal[data-activitycode="${code}"][data-activitytype="toolVideo"]`);

                if (toolVideo.length == 0 && refreshType.toLowerCase() !== "external") {
                    // replace url back to what it was pre-fullpagequiz launch
                    history.replaceState(history.state, "", history.state.prevurl);
                    localStorage.setItem("closed", "true");
                    localStorage.setItem("code", "");

                }

                
                var options = {
                    url: '/account/chipsandxp',
                    type: 'GET',
                    data: {}
                };

                self.callApi(options).done(function (data) {
                    self.options.user.chipCount = data.chips;
                    self.options.user.xp = data.xp;
                    $("#NavChipCount").html(new Intl.NumberFormat().format(data.chips));
                });

                //Refresh details modal
                //if there are multiple instances of the modal on the page, pick the first one, preferably which has been opened
                var $modal = $('.education35-modal[data-activitycode="' + code + '"][data-has-opened="1"]').first();
                if ($modal.length == 0) {
                    $modal = $('.education35-modal[data-activitycode="' + code + '"]').first();
                }

                if ($modal.length > 0) {
                    var $modalcontent = $modal.find(".educationdetail35-modal-content");
                    $modalcontent.find('.education-detail35-placeholder').siblings().remove();
                    $modalcontent.find('.education-detail35-placeholder').removeClass('hidden');

                    //open details modal after module is closed, if it wasn't already open
                    if (!$modal.is(":visible")) {
                        // reinit if need be 
                        const zfPluginId = $modal.data('e');
                        if ((typeof zfPluginId) === 'undefined') {
                            new Foundation.Reveal($modal);
                        }
                        $modal.foundation('open');
                    }

                    setTimeout(function () {
                        self.getHtml({
                            type: "GET",
                            url: `/education/details`,
                            data: { code: code }
                        }).done(function (data) {

                            $modalcontent.find('.education-detail35-placeholder').addClass('hidden');
                            $modalcontent.append(data);

                            //is this happening in the context of an unfinished track page?
                            var $trackProgress = $(document).find('.education35-progress-track-unfinished');

                            //refresh relevant thumbnails if the item is now completed
                            var nowComplete = $modalcontent.find('.education-item-launch[data-completed="True"]');
                            if (nowComplete.length > 0) {

                                var $thumbCard = $('.education-item35[data-activitycode="' + code + '"]');
                                var $attributes = $thumbCard.find(".education-attributes");
                                var $launch = $thumbCard.find(".education-item35-launch");
                                var $progress = $thumbCard.find(".education35-progress");
                                var $smallMobileImgOverlay = $thumbCard.find('.education35-minilist-img-overlay');

                                $attributes.addClass("refreshing");
                                $launch.addClass("refreshing");

                                //if this item is being closed on a promotional page, the promo-specific completed item class needs to be applied
                                var $promotional = $('.promotional-edu35-list');

                                if ($promotional.length > 0) {
                                    //is there a start date on the promotional education list?
                                    var startDate = $promotional.attr("data-start-date");
                                    var lastCompletedDate = $modalcontent.find('#last-completed').attr("data-last-completed");

                                    //if the promo item is previously-completed, before the promo list start date, and is closed without re-completing it, 
                                    //we should not refresh background edu items to the complete state
                                    var proceedThumbnailRefresh = true;
                                    try {
                                        var sDate = new Date(startDate);
                                        var lcDate = new Date(lastCompletedDate);

                                        if (sDate > lcDate) {                                               
                                            proceedThumbnailRefresh = false;
                                        }                                       
                                    }
                                    catch {}

                                    if (proceedThumbnailRefresh == true) {
                                        var doneClass = $promotional.attr("data-done-class");
                                        if (typeof doneClass != "undefined" && doneClass.length > 0) {
                                            //don't impact non-promotional lists potentially on same page
                                            $promotional.find('.education-item35[data-activitycode="' + code + '"]').addClass(doneClass);
                                        }
                                    }
                                }


                                //switch button to "retake", hide progress 
                                $launch.find(".education-item-launch").not('.show-on-completion').addClass("hidden");
                                $launch.attr("data-item-completed", "true");
                                if ($progress != null) {
                                    $progress.addClass("hidden");
                                }
                                $launch.find(".education-item-launch").siblings(".show-on-completion").removeClass("hidden");

                                //remove credits attribute from card if they are there
                                var $credits = $attributes.find('.credits-available');
                                if ($credits != null) {
                                    $credits.addClass("hidden");
                                    //re-assign sizing classes for remaining attributes
                                    $attributes.find('div').removeClass("small-4").addClass("small-6");
                                }

                                //reveal img overlay for small + mobile
                                $smallMobileImgOverlay.removeClass("hidden");

                                $attributes.removeClass("refreshing");
                                $launch.removeClass("refreshing");

                                //if we are on a track details page, update track progress
                                var $trackElement = $trackProgress.parents('.education-detail35-track');
                                if ($trackProgress.length > 0) {
                                    //since the edu list is on the page in 2 form factors for diff screen sizes, just check one of them instead of dividing
                                    var completedCount = $trackElement.find('.show-for-small-only').find('.education-item35-launch[data-item-completed="true"]').length;
                                    var completedProgress = $trackProgress.find('span[data-completed-progress="True"]').length;

                                    var $newProgress;
                                    while (completedCount > completedProgress) {
                                        $newProgress = $trackProgress.find('span[data-completed-progress="False"]').first();

                                        if ($newProgress.length > 0) {
                                            $newProgress.addClass('background-color--green35');
                                            $newProgress.removeClass('background-color--dark-gray35');
                                            $newProgress.attr("data-completed-progress", "True");
                                        }
                                        else {
                                            //the track has been finished and the page should reload
                                            location.reload();
                                        }
                                        completedProgress++;
                                    }

                                    //if the final track item has been completed, the exam needs unlocked. 
                                    if ($trackProgress.find('span[data-completed-progress="False"]').length <= 1) {

                                        var trackCode = $('.education-detail35-track').attr('data-track-code');
                                        var options = {
                                            url: '/education35/trackexam',
                                            type: 'GET',
                                            data: { code: trackCode }
                                        };

                                        self.getHtml(options).done(function (data) {
                                            $('.exam-btn').parent().html(data);
                                            $('.education-detail35-track').trigger('wire-track-exam-launch', {});
                                        });
                                    }

                                }
                            }
                        });
                    }, refreshTimeout);
                }
                else {
                    //this is being called on a standalone details page, and the page refresh is the better strategy
                    location.reload();
                }
            }
            else if (refreshType.toLowerCase() === "learn") {
                window.location.href = this.generateSiteLink("learning/featured");
            }
            else if (refreshType.toLowerCase() === "full") {
                location.reload();
            }
        };
    }

    /*!
    * jQuery serializeObject - v0.2 - 1/20/2010
    * http://benalman.com/projects/jquery-misc-plugins/
    * 
    * Copyright (c) 2010 "Cowboy" Ben Alman
    * Dual licensed under the MIT and GPL licenses.
    * http://benalman.com/about/license/
    */

    // Whereas .serializeArray() serializes a form into an array, .serializeObject()
    // serializes a form into an (arguably more useful) object.

    (function ($, undefined) {
        '$:nomunge'; // Used by YUI compressor.

        $.fn.serializeObject = function () {
            var obj = {};

            $.each(this.serializeArray(), function (i, o) {
                var n = o.name,
                    v = o.value;

                obj[n] = obj[n] === undefined ? v
                    : $.isArray(obj[n]) ? obj[n].concat(v)
                        : [obj[n], v];
            });

            return obj;
        };
    })(jQuery);
}
